import { FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorsService } from '../../shared/services/validators.service';
var CreateExperimentModalComponent = /** @class */ (function () {
    function CreateExperimentModalComponent(formBuilder, bsModalRef, validatorsService) {
        this.bsModalRef = bsModalRef;
        this.facilities = [];
        this.aois = [];
        this.minPlantDate = new Date();
        this.onClose = new Subject();
        this.onCreateExperiment = new Subject();
        this.createExperimentForm = formBuilder.group({
            facility: formBuilder.control(null, [Validators.required]),
            prismExperimentName: formBuilder.control(null, [Validators.required]),
            aoi: formBuilder.control(null, Validators.required),
            actualPlantDate: formBuilder.control({ value: null, disabled: false }, [
                Validators.required, validatorsService.mustBeOnOrAfterDate(this.minPlantDate), validatorsService.isValidDate
            ])
        });
    }
    Object.defineProperty(CreateExperimentModalComponent.prototype, "actualPlantDate", {
        get: function () { return this.createExperimentForm.get('actualPlantDate'); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(CreateExperimentModalComponent.prototype, "facility", {
        get: function () { return this.createExperimentForm.get('facility'); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(CreateExperimentModalComponent.prototype, "prismExperimentName", {
        get: function () { return this.createExperimentForm.get('prismExperimentName'); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(CreateExperimentModalComponent.prototype, "aoi", {
        get: function () { return this.createExperimentForm.get('aoi'); },
        enumerable: true,
        configurable: true
    });
    ;
    CreateExperimentModalComponent.prototype.ngOnInit = function () {
        this.createExperimentForm.setValue({
            facility: null,
            aoi: null,
            prismExperimentName: this.request.requestNumber,
            actualPlantDate: this.ceLogistics.plannedPlantingDate
        });
        this.plannedAOILocation = this.planningNotes.plannedAoiLocation;
    };
    CreateExperimentModalComponent.prototype.close = function () {
        this.onClose.next();
    };
    CreateExperimentModalComponent.prototype.createExperiment = function () {
        var formValue = this.createExperimentForm.value;
        this.onCreateExperiment.next({
            id: this.request.id,
            facilityId: formValue.facility,
            prismExperimentName: formValue.prismExperimentName,
            aoiId: formValue.aoi.prismId,
            aoiName: formValue.aoi.name,
            actualPlantDate: formValue.actualPlantDate,
            trialManagerID: formValue.aoi.id
        });
    };
    return CreateExperimentModalComponent;
}());
export { CreateExperimentModalComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/create-experiment-modal/create-experiment-modal.component.ts.pre-build-optimizer.js